import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractDeliveryRefundDefinitionCreateForm from "./create";
import ContractDeliveryRefundDefinitionEditForm from "./edit";
import {
  deleteDeliveryRefundDefinition,
  getDeliveryRefundDefinitionDetails,
  getDeliveryRefundDefinitions,
} from "src/store/contract-pickup-definition/saga";
import {
  DeliveryRefundDefinitionDetailDto,
  DeliveryRefundDefinitionDto,
} from "src/store/contract-pickup-definition/type";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import { useNavigate } from "react-router";

const ContractDeliveryRefundDefinitionsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<DeliveryRefundDefinitionDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const navigate = useNavigate();
  const [selected, setSelected] = useState<DeliveryRefundDefinitionDetailDto>();
  const columns = [
    {
      text: t("Contract.DeliveryRefundDefinition.Name"),
      dataField: "Name",
    },
  ];
  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.DeliveryRefundDefinition.PageTitle")}
        metaTag={t("Contract.DeliveryRefundDefinition.MetaTag")}
        gridProps={{
          addTitle: t("Contract.DeliveryRefundDefinition.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getDeliveryRefundDefinitions,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getDeliveryRefundDefinitionDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          gridButtons(keyValue, data) {
            if (data.DataTypeId === 3) {
              return (
                <ColumnButton
                  buttonType={"custom"}
                  custombutton={{
                    text: t(
                      "Contract.DeliveryRefundDefinition.OptionsButton"
                    ).toString(),
                  }}
                  onClick={() =>
                    navigate(
                      "/contract/pickup-dropoff-definitions/picklist/" + data.Id
                    )
                  }
                />
              );
            }
          },
          deleteButton: {
            text: (id, data: any) =>
              t("Contract.DeliveryRefundDefinition.DeleteQA", {
                name: data.Name,
              }),
            action: deleteDeliveryRefundDefinition,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ContractDeliveryRefundDefinitionCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getDeliveryRefundDefinitions,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractDeliveryRefundDefinitionEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getDeliveryRefundDefinitions,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractDeliveryRefundDefinitionsPage;
